// @ts-strict-ignore
import type { LazyQueryHookOptions, QueryHookOptions } from "@apollo/client";
import { useLazyQuery, useQuery, gql } from "@apollo/client";

import type { PageInfoFragment } from "@shared/data/fragments/PageInfoFragment/PageInfoFragment.fragment";
import { PAGE_INFO_FRAGMENT } from "@shared/data/fragments/PageInfoFragment/PageInfoFragment.fragment";
import type { Typeahead } from "@shared/types/graphqlGenerated";

const TypeaheadSearch_Shared_Query = gql`
  query TypeaheadSearch_Shared_Query(
    $query: String
    $first: Int
    $last: Int
    $after: String
    $before: String
    $filters: SearchFilterObject
    $searchSessionId: String
  ) {
    viewer {
      typeaheadSearch(
        query: $query
        first: $first
        last: $last
        after: $after
        before: $before
        filters: $filters
        searchSessionId: $searchSessionId
      ) {
        nodes {
          id
          name
          entityType
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
    }
  }
  ${PAGE_INFO_FRAGMENT}
`;

interface TypeaheadSearchData {
  viewer: {
    typeaheadSearch: {
      nodes: Pick<Typeahead, "id" | "name" | "entityType">[];
      pageInfo: PageInfoFragment;
      totalCount: number;
    };
  };
}

type TypeaheadFilterListFieldFragment =
  | "INGREDIENTS"
  | "BRANDS"
  | "SUPPLEMENT_TYPES"
  | "CONDITIONS";

interface SearchFilterObject {
  list: TypeaheadFilterListFieldFragment[];
}

interface Variables {
  query: string;
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  filters?: SearchFilterObject;
  searchSessionId?: string;
}

const useTypeaheadSearchQuery = (options?: QueryHookOptions<TypeaheadSearchData, Variables>) =>
  useQuery(TypeaheadSearch_Shared_Query, options);

const useTypeaheadSearchLazyQuery = (
  options?: LazyQueryHookOptions<TypeaheadSearchData, Variables>
) => useLazyQuery(TypeaheadSearch_Shared_Query, options);

export type { TypeaheadSearchData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export { useTypeaheadSearchQuery, useTypeaheadSearchLazyQuery, TypeaheadSearch_Shared_Query };
